import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyBodyMeasurements, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { MY_BODY_MEASUREMENTS_GET, MY_BODY_MEASUREMENTS_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useUserMeasurements = () => {
  const dispatch = useDispatch();
  const myBodyMeasurements = useSelector(state => state.userTrainingInfo.myBodyMeasurements);

  useEffect(() => {
    if (myBodyMeasurements.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMyBodyMeasurements());
    }
  }, [dispatch, myBodyMeasurements.status]);

  useEffectOnSuccess([state => state.userTrainingInfo.updateMyBodyMeasurements], () => {
    dispatch(resetState(MY_BODY_MEASUREMENTS_GET));
    dispatch(resetState(MY_BODY_MEASUREMENTS_UPDATE));
  });

  return myBodyMeasurements;
};

export default useUserMeasurements;
